import { Product } from '../../../../types/catalog';
import { Link } from 'react-router-dom';
import Carousel from './carousel';
import { SwiperProps } from 'swiper/react/swiper-react';
import { selectImage } from '../../../../util/misc';

function ProductCarousel({ products, swiperProps = {} }: { products: Product[]; swiperProps?: SwiperProps }) {
    return (
        <Carousel
            items={products}
            swiperProps={swiperProps}
            itemRenderFn={({ url, imageUrl, imageVariants, shortName }) => {
                const imgUrl = selectImage(imageVariants, 200, 100, imageUrl);
                return (
                    <Link to={url} className="swiper-slide catalog-item">
                        <div className="catalog-item-card">
                            <div
                                className="catalog-item-card__image"
                                style={{
                                    backgroundImage: imgUrl ? `url('${imgUrl}')` : 'none',
                                }}
                            />
                            <div className="catalog-item-card__title">{shortName}</div>
                        </div>
                    </Link>
                );
            }}
        />
    );
}

export default ProductCarousel;
